import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/base/SectionHeading";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import SearchBand from "@/pages/home/components/SearchBand";
import CategoryStrip from "@/pages/home/components/CategoryStrip";
import PopularRanking from "@/pages/home/components/PopularRanking";
import { getLatest } from "@/lib/catalog";
import { usePageSeo } from "@/hooks/usePageSeo";
import { useReveal } from "@/hooks/useReveal";

export default function Home() {
  const latest = getLatest(8);

  usePageSeo({
    title: "蜜桃成熟时电影 - 高清电影资源与剧情介绍平台",
    description:
      "蜜桃成熟时电影为您提供丰富的影视资源和详细剧情介绍，涵盖多部电影作品，方便用户了解电影内容和观看信息。",
    keywords: "蜜桃成熟时电影,电影资源,电影剧情,影视平台,电影介绍,高清影视,影视资源观看",
  });
  useReveal(["home"]);

  return (
    <SiteLayout>
      <HeroCarousel />
      <SearchBand />
      <CategoryStrip />

      <section className="w-full px-4 md:px-8 mt-16 md:mt-20">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2">
            <SectionHeading
              eyebrow="New releases"
              title="最新上映"
              desc="近期上线的高清电影资源，抢先了解剧情亮点"
              moreTo="/category"
              moreLabel="更多新片"
            />
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-5">
              {latest.map((m) => (
                <MovieCard key={m.id} movie={m} />
              ))}
            </div>
          </div>
          <div className="lg:col-span-1">
            <div className="mb-6 md:mb-8">
              <span className="inline-flex items-center gap-1.5 text-xs font-label tracking-[0.2em] text-primary-600 uppercase mb-2">
                <span className="w-5 h-px bg-primary-400"></span>
                Ranking
              </span>
            </div>
            <PopularRanking />
          </div>
        </div>
      </section>

      {/* Brand intro band */}
      <section className="w-full px-4 md:px-8 mt-16 md:mt-20">
        <div className="reveal rounded-lg overflow-hidden bg-secondary-900 grid grid-cols-1 lg:grid-cols-2">
          <div className="p-8 md:p-12 flex flex-col justify-center">
            <span className="inline-flex items-center gap-2 self-start px-3 py-1 rounded-full bg-primary-500/20 text-primary-300 text-xs font-label mb-5">
              <i className="ri-film-line"></i>
              关于蜜桃成熟时电影
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 leading-snug mb-4">
              把每一部电影的剧情，讲清楚
            </h2>
            <p className="text-background-300 text-sm md:text-base leading-7 mb-6">
              我们为电影爱好者整理了丰富的电影资源信息与剧情介绍，从题材、地区、年份多维度梳理，
              让了解一部电影、找到下一部想看的作品变得更简单、更高效。
            </p>
            <div className="grid grid-cols-3 gap-4 mb-7">
              {[
                { n: "18+", l: "收录影片" },
                { n: "14", l: "题材分类" },
                { n: "4", l: "地区覆盖" },
              ].map((s) => (
                <div key={s.l}>
                  <p className="font-heading font-bold text-2xl md:text-3xl text-accent-400">{s.n}</p>
                  <p className="text-xs text-background-400 mt-1">{s.l}</p>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 self-start h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="relative min-h-[260px] lg:min-h-full">
            <img
              src="https://readdy.ai/api/search-image?query=Movie%20theater%20seats%20and%20a%20glowing%20screen%20in%20warm%20amber%20and%20peach%20cinematic%20light%2C%20cozy%20artistic%20interior%2C%20soft%20bokeh%2C%20premium%20cinema%20atmosphere%2C%20no%20text&width=1000&height=900&seq=movie-intro-band&orientation=landscape"
              alt="蜜桃成熟时电影平台介绍"
              title="蜜桃成熟时电影 - 影视资源与剧情介绍"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-r from-secondary-900 via-secondary-900/40 to-transparent"></div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}